import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { Card } from '../../../../../../packages/utx-access-client/src/react';

export interface ChangeATMPINModalProps {
  onLayout: (event: any) => void;
}

export enum ChangeATMPINStackRoutes {
  Main = 'main',
  Confirm = 'confirm',
  Placed = 'placed'
}

export type ChangeATMPINStackParamList = {
  [ChangeATMPINStackRoutes.Main]: ChangeATMPINModalProps & {
    account: string;
    tab?: number;
    onData: (data: any) => void;
    record?: Card;
    func?: (cardId: string, pin: string, onSuccess?: (data: any) => void, onError?: (error: any) => void) => void;
    onReturnData?: (data: any) => void;
  };
  [ChangeATMPINStackRoutes.Confirm]: ChangeATMPINModalProps & {
    account: string;
    tab?: number;
    data: any;
    record?: Card;
    func?: (cardId: string, pin: string, onSuccess?: (data: any) => void, onError?: (error: any) => void) => void;
    onReturnData?: (data: any) => void;
  };
  [ChangeATMPINStackRoutes.Placed]: ChangeATMPINModalProps & { account: string; tab?: number; data: any; returnData?: any };
};

export type ChangeATMPINStackScreenProps<Screen extends keyof ChangeATMPINStackParamList> = NativeStackScreenProps<
  ChangeATMPINStackParamList,
  Screen
>;
